export const pendingOrdersEs = {
    title: 'Pedidos Pendientes',
    subtitle: 'productos pendientes de preparar',
    loading: 'Cargando pedidos pendientes...',
    error: 'Error al cargar los pedidos pendientes',
    noData: 'No hay pedidos pendientes',
    noDataDescription: 'Todos los pedidos han sido procesados.',
    quantity: 'cantidad',
    orderNumber: 'Pedido #',
    productCode: 'Código:',
}; 